module.exports = __webpack_public_path__ + "img/TD.7e448065.svg";